import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setBillingExplorerChartSettings,
  setForecastSuggestionPopoverOpen,
} from "../../resourceExplorerSlice";
import { ChartSettings } from "@/services/cloudchipr.api";
import { isForecastSupportedDateRange } from "@/store/resource-explorer/utils/helpers/isForecastSupporteddateRange";
import { RootState } from "@/store/store";

export const updateBillingExplorerChartSettingsThunk = createAsyncThunk(
  "resourceExplorer/updateBillingExplorerChartSettings",
  async (chartSettings: Partial<ChartSettings>, { dispatch, getState }) => {
    const state = getState() as RootState;
    const dates = state.resourceExplorer.data?.dates;

    if (
      chartSettings.display_forecast &&
      !isForecastSupportedDateRange(dates)
    ) {
      dispatch(setForecastSuggestionPopoverOpen(true));
    }

    dispatch(setBillingExplorerChartSettings(chartSettings));
  },
);
